var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3406,
    height: 2369,
    viewBox: "0 0 3406 2369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "5_93",
    d: "M902.053 871.027L775.147 676.702L1045.46 501.79L1171.62 696.527L902.053 871.027Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "5_94",
    d: "M1029.05 1065.33L902.148 871.009L1171.97 696.595L1298.62 890.835L1029.05 1065.33Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "5_89",
    d: "M707.025 1278.37L580.428 1084.52L850.246 910.104L976.587 1103.87L707.025 1278.37Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "5_88",
    d: "M826.134 1461.68L707.127 1279.51L976.924 1105.07L1095.68 1287.15L826.134 1461.68Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "5_86",
    d: "M1101.58 1885.97L969.145 1683.01L1208.14 1528.65L1329.87 1715.11L1305.72 1730.57L1304.86 1731.11L1305.43 1731.96L1315.87 1747.62L1101.58 1885.97Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "5_87",
    d: "M961.956 1669.89L826.447 1462.32L1095.99 1287.27L1182.94 1410.48L1183.51 1411.29L1184.32 1410.73L1195.97 1402.81L1248.38 1485.11L961.956 1669.89Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "5_95",
    d: "M1232.1 1379.87L1150.07 1252.28L1419.92 1077.9L1555.38 1285.7L1264.56 1473.52L1213.14 1393.21L1231.8 1381.25L1232.64 1380.71L1232.1 1379.87Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "5_90",
    d: "M580.957 1084.34L453.09 888.538L722.912 714.129L850.521 909.847L580.957 1084.34Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "5_91",
    d: "M682.883 676.972L712.728 720.284L582.591 803.715L452.422 887.166L294.991 643.663L587.472 451.294L718.823 651.617L683.149 675.574L682.309 676.138L682.883 676.972Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "5_92",
    d: "M717.065 649.049L587.655 451.71L889.01 261.539L1045.62 501.835L786.059 669.524L757.601 625.366L757.072 624.544L756.238 625.055L717.065 649.049Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "5_57",
    d: "M2405.76 1127.41V1145.91H2350.76V782.408H2634.76V894.408V895.408H2635.76H2696.26V961.408H2686.26H2685.26V962.408V1028.41H2641.26H2640.26V1029.41V1126.41H2406.76H2405.76V1127.41Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "5_58",
    d: "M2695.76 895.408H2635.26V782.408H3064.26V1028.41H2685.26V962.408H2695.76H2696.76V961.408V896.408V895.408H2695.76Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "5_59",
    d: "M2640.76 1125.91V1028.41H3064.26V1369.91H2630.76V1126.91H2639.76H2640.76V1125.91Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "5_60",
    d: "M3064.26 1369.91L3064.76 1712.41H2764.26V1623.41V1622.41H2763.26H2630.76V1369.91H3064.26Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "5_61",
    d: "M2870.76 1965.91V2020.41H2630.76V1622.91H2763.76V1711.41V1712.41H2764.76H3064.76V1838.91H3012.26H3011.26V1839.91V1964.91H2871.76H2870.76V1965.91Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "5_80",
    d: "M2449.29 1625.41L2619.76 1627.38V2020.41H2509.94H2373.76V1625.41H2449.28H2449.29Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "5_81",
    d: "M2373.76 1698.41L2373.76 2020.41H2268.86H2138.76V1698.41H2373.76Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "5_82",
    d: "M2138.76 1698.41L2138.76 2020.41H2036.09H1908.76V1698.41H2138.76Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "5_83",
    d: "M1908.76 1698.41L1908.76 2020.41H1805.2H1676.76V1698.41H1908.76Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "5_84",
    d: "M1676.76 1698.41L1676.76 2020.41H1573.2H1444.76V1698.41H1676.76Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "5_85",
    d: "M1315.3 1748.75L1316.16 1748.19L1315.59 1747.35L1304.66 1731.2L1330.2 1714.82L1379.92 1698.41H1444.76V1971.41H1341.2H1212.3L1140.15 1861.7L1315.3 1748.75Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "5_79",
    d: "M2373.76 1625.41V1637.41H2268.86H2138.76V1315.41H2210.89H2373.76V1568.91V1569.91H2374.76H2382.76V1624.41H2374.76H2373.76V1625.41Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "5_78",
    d: "M2036.19 1637.41H1908.76V1315.41H1979.41H2138.94V1637.41H2036.19Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "5_77",
    d: "M1675.73 1403.91V1315.41H1747.26H1908.76V1637.41H1804.74H1687.76V1631.91V1630.91H1686.76H1668.14V1562.41V1561.41H1667.14H1638.26V1404.91H1674.73H1675.73V1403.91Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor5);
export default __webpack_public_path__ + "static/media/select_floor_5.859dde7135084d167b6f4a5d51f5c707.svg";
export { ForwardRef as ReactComponent };